import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const PlayoffHistory = ({ leagueData }) => {
  const { eliminatedCount, userCount } = leagueData;

  const rounds = Object.values(leagueData?.rounds)
    .filter((item) => item.settled)
    .sort((a, b) => a.sort_order - b.sort_order);

  const labels = rounds.map((item) => `R${item.sort_order}`);

  const dataset = rounds.reduce(
    (acc, val) => {
      return [
        ...acc,
        acc[acc.length - 1] - val.eliminatedCount ? val.eliminatedCount : 0,
      ];
    },
    [userCount]
  );

  const options = {
    layout: {
      padding: {
        top: 20,
        right: 30,
        bottom: 0,
        left: 30,
      },
    },
    tooltips: {
      enabled: false,
    },

    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      filler: {
        propagate: false,
      },
      tooltip: {
        enabled: false,
      },

      datalabels: {
        labels: {
          title: {},
          value: {},
        },
      },
      autocolors: false,
    },
    scales: {
      x: {
        beginAtZero: true,
        position: "bottom",

        grid: {
          drawBorder: false,
        },
        ticks: {
          padding: -2,
          autoSkip: false,
          minRotation: 0,
          maxRotation: 0,

          color: "rgba(255, 255, 255, 0.8)", // Set the color to white for Y-axis labels
          font: {
            weight: "bold",
          },
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        data: dataset,
        backgroundColor: (context) => {
          const index = context.dataIndex;
          const dataset = context.dataset.data;
          const lastValue = dataset[dataset.length - 1];

          return index === dataset.length - 1
            ? "rgba(236, 72, 153, 1)"
            : "rgba(236, 72, 153, 0.8)";
        },

        datalabels: {
          anchor: "end",
          align: "top",
          offset: 0,
          font: {
            weight: "bold",
          },
          padding: 2, // Adjust the padding as per your requirement
          color: (context) => {
            const data = context.dataset.data;
            const value = data[context.dataIndex];
            const lastValue = data[data.length - 1];
            return value === lastValue
              ? "rgba(255, 255, 255, 1)"
              : "rgba(255, 255, 255, 0.5)";
          },
        },
      },
    ],
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100px",
        position: "relative",
      }}
    >
      <Bar options={options} data={data} />
    </div>
  );
};

export default PlayoffHistory;
